import {
    $createTextNode,
    $getSelection,
    $isRangeSelection,
    $isTextNode,
    LexicalEditor
} from 'lexical';
import {getSelectionPoints} from '../../../utils/lexical/getSelectionPoints';
import {TVoidFunction} from '../types';
import {languageTabs} from '../../Automations/components/RuleDialog/parts/AutomationActionToolbar/constants';
import {defaultContext} from '../reducer/model';
import {IMessagesValues} from '../EmailDialog';
import {priority} from '@priority-software/priority-proto-api/lib';
import {getActiveMessageLang} from '../../Automations/components/RuleDialog/parts/AutomationActionTemplate/BusinessRuleActionTemplate/utils';
import {TreeNodeProps} from '@priority-software/priority-style-react';
import {
    replaceIdsWithTitles,
    replaceIdsWithTitlesForHtml,
    replaceTitlesWithIds
} from './treeActions';
import {isBase64} from '../../../utils/base64';

export const updateEditorSelection = (
    editor: LexicalEditor,
    content: string,
    cb?: TVoidFunction
) => {
    editor.focus();

    editor.update(() => {
        const selection = $getSelection();
        if ($isRangeSelection(selection)) {
            const [start, end] = getSelectionPoints(selection);
            const selectionNewEnd = start + content.length;
            const node = selection.anchor.getNode();
            if (selection.focus.key === selection.anchor.key && start === end) {
                selection.insertText(content);
            } else {
                if ($isTextNode(node)) {
                    const deleteCoords: [number, number] =
                        start === end ? [0, node.getTextContent().length] : [start, end - start];
                    node.spliceText(...deleteCoords, content);
                } else {
                    node.getChildren().length;
                    node.splice(0, node.getChildren().length, [$createTextNode(content)]);
                }
                node.select(start, selectionNewEnd);
            }

            cb?.();
        }

        return false;
    });
};

export const wrapValueWithDiv = (value: string) => value || '';

export const renderDefault = (messagesValues: IMessagesValues, treeValues?: TreeNodeProps) => {
    const language =
        messagesValues?.initActiveBySubject?.Language?.toString() || getActiveMessageLang();

    const addLanguage = languageTabs.reduce((acc, tab) => {
        const initialValues: priority.netitems.form.IAlertMessage =
            messagesValues.Messages[tab.lang];
        const editorSubject = replaceIdsWithTitles(initialValues?.Subject || '', treeValues) || '';
        const editorSubjectIds =
            replaceTitlesWithIds(initialValues?.Subject || '', treeValues) || '';
        const emailHtml = wrapValueWithDiv(
            replaceIdsWithTitlesForHtml(initialValues?.Message, treeValues)
        );

        acc[tab.id] = {
            editorSubject,
            editorSubjectIds,
            emailHtml
        };
        return acc;
    }, {});

    return {
        states: {
            ...defaultContext.states,
            ...addLanguage,
            treeValues,
            language
        }
    };
};

export const getUt8Array = (base64: string) => {
    const condition = isBase64(base64);
    if (condition) {
        const binaryString = atob(base64);
        return new Uint8Array(binaryString.split('').map(char => char.charCodeAt(0)));
    }

    return null;
};
